import React from 'react';
import { Card } from 'primereact/card';
import GenericTableFilter from '../../../../../components/common/GenericTableFilter';

/**
 * Vehicle Registration filters component for filtering vehicle registration data
 */
const VehicleRegistrationFilters = ({ filterFields, columns, handleSearch, handleApplyFilters, handleResetFilters, customFilterTypes = {}, customFilterOptions = {} }) => {
    return (
        <GenericTableFilter 
            filterFields={filterFields} 
            columns={columns} 
            initialFilters={{}} 
            onSearch={handleSearch} 
            onApplyFilters={handleApplyFilters} 
            onResetFilters={handleResetFilters}
            customFilterTypes={customFilterTypes}
            customFilterOptions={customFilterOptions}
        />
    );
};

export default VehicleRegistrationFilters;
